import React from 'react'
import { SearchLoadingContainer, SearchLoadingText } from '../styles'

export const SearchFallback: React.FC = () => (
  <SearchLoadingContainer
    role="status"
    aria-live="polite"
    aria-label="Loading search results"
  >
    <SearchLoadingText>Loading...</SearchLoadingText>
  </SearchLoadingContainer>
)

export const ResultsFallback: React.FC = () => (
  <SearchLoadingContainer
    role="status"
    aria-live="polite"
    aria-label="Loading search results"
  >
    <SearchLoadingText>Loading results...</SearchLoadingText>
  </SearchLoadingContainer>
)
